import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';

import SeathruThemeProvider from '@src/theme/SeathruThemeProvider';

import { store } from '@store/store';

import { Spin } from 'antd';

import './input.css';
import 'antd/dist/antd.variable.min.css';
import './assets/scss/style.scss';

// ** Lazy load app
const LazyApp = lazy(() => import('./App'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Provider store={store}>
        <Suspense fallback={<Spin />}>
          <SeathruThemeProvider>
            <LazyApp />
          </SeathruThemeProvider>
        </Suspense>
      </Provider>
    </BrowserRouter>
  </QueryClientProvider>,
);

